import { useGetParticipants } from 'api-hooks/tour/tour-list/partipant/query';
import { CloseSVG } from 'common/assets';
import stylesColors from 'common/styles/styles.colors';
import {
  DrawerBody,
  DrawerFooter,
  DrawerHeaderContainer,
  DrawerLeftContainer,
  DrawerRightContainer,
} from 'components/common/drawer/styles';
import PaginationComponent from 'components/elements/pagination-component';
import TableComponent, {
  IColumn,
} from 'components/elements/table-component/table-component';
import Text from 'components/elements/text';
import { Action } from 'components/styles';
import { useApplyQueryFilter } from 'hooks/filter/use-apply-query-filter';
import useApplyQuerySort from 'hooks/use-apply-query-sort';
import useComposedQuery from 'hooks/use-composed-query';
import { FooterDivider } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import ExportToExcel from '../export-to-excel';

interface Props {
  id: string;
  onClose: () => void;
}

export default function ListParticipantPanel(props: Props) {
  const { t } = useTranslation();
  const { id, onClose } = props;
  const [page, setPage] = React.useState<number>(1);

  const _columns = React.useMemo<IColumn<any>[]>(
    () => [
      {
        header: t('common:guest'),
        accessorKey: 'titledName',
        minSize: 150,
        size: 150,
        sortName: 'name',
      },

      {
        header: t('common:bed'),
        accessorKey: 'bedType',
        minSize: 100,
        size: 100,
      },
      {
        header: t('common:group'),
        accessorKey: 'groupNumber',
        minSize: 100,
        size: 100,
        sortName: 'group',
      },
      {
        header: t('common:schedule'),
        accessorKey: 'schedule',
        minSize: 200,
        size: 200,
      },
    ],
    [t],
  );

  const {
    data,
    isFetching,
    extras: [, { columns }],
  } = useComposedQuery(
    useGetParticipants,
    {
      id,
      params: {
        page,
        limit: -1,
      },
    },
    useApplyQueryFilter((data: any) => {
      return data.filters;
    }),
    useApplyQuerySort((data: any) => {
      return data.sorts;
    }, _columns),
  );

  const items = data?.data || [];
  const showExport = !isFetching && items.length > 0;

  return (
    <>
      <DrawerHeaderContainer>
        <DrawerLeftContainer>
          <Text variant="title3Bold">{t('common:participant_list')}</Text>
        </DrawerLeftContainer>
        <DrawerRightContainer>
          <ExportToExcel
            data={items}
            filename={`participant-list-${id}`}
            buttonProps={{
              isLoading: isFetching,
              disabled: !showExport,
            }}
          />
          <Action onClick={onClose}>
            <CloseSVG />
          </Action>
        </DrawerRightContainer>
      </DrawerHeaderContainer>
      <DrawerBody>
        <TableComponent
          data={data?.data || []}
          headerColor={stylesColors.bg1}
          columns={columns}
          isLoading={isFetching}
        />
        <FooterDivider />

        <DrawerFooter $style={{ justifyContent: 'center' }}>
          <PaginationComponent
            page={page}
            onPageChange={(page) => setPage(page)}
            meta={data?.meta}
          />
        </DrawerFooter>
      </DrawerBody>
    </>
  );
}
